var _g, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCyberSecurityIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1937_4287)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.493164,
    width: 50,
    height: 50,
    rx: 12,
    fill: "url(#paint0_linear_1937_4287)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.993164,
    width: 49,
    height: 49,
    rx: 11.5,
    stroke: "url(#paint1_radial_1937_4287)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.993164,
    width: 49,
    height: 49,
    rx: 11.5,
    stroke: "url(#paint2_radial_1937_4287)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.993164,
    width: 49,
    height: 49,
    rx: 11.5,
    stroke: "url(#paint3_radial_1937_4287)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.8061 15.5432C24.9442 15.4763 25.1053 15.4765 25.2432 15.5437L27.0904 16.4441C28.5252 17.1434 30.0999 17.5136 31.6982 17.5271L33.0039 17.5382C33.2783 17.5405 33.4996 17.7636 33.4996 18.0381V26.1744C33.4996 31.0119 30.187 35.2254 25.4695 36.3978L25.145 36.4784C25.0661 36.498 24.9835 36.4981 24.9045 36.4786L24.544 36.3895C19.8196 35.2223 16.4996 31.0055 16.4996 26.1626V18.0066C16.4996 17.7305 16.7235 17.5066 16.9996 17.5066H18.2912C19.9119 17.5066 21.5111 17.1397 22.9676 16.434L24.8061 15.5432ZM25.0235 16.5491L23.4037 17.3339C21.8111 18.1056 20.0627 18.5066 18.2912 18.5066H17.4996V26.1626C17.4996 30.5417 20.5021 34.3608 24.7839 35.4187L25.0241 35.478L25.2283 35.4273C29.5038 34.3647 32.4996 30.5485 32.4996 26.1744V18.5339L31.6898 18.5271C29.9427 18.5123 28.2211 18.1076 26.6523 17.343L25.0235 16.5491ZM28.312 22.6027C28.5276 22.7752 28.5626 23.0899 28.3901 23.3055L24.3904 28.3055C24.2997 28.4189 24.1642 28.4873 24.019 28.4928C23.8739 28.4983 23.7336 28.4405 23.6345 28.3344L21.6341 26.1915C21.4457 25.9896 21.4566 25.6732 21.6584 25.4848C21.8603 25.2964 22.1767 25.3073 22.3651 25.5091L23.9708 27.2292L27.6092 22.6808C27.7817 22.4652 28.0963 22.4302 28.312 22.6027Z",
    fill: "#BB85FF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1937_4287",
    x: -7.9,
    y: -7.40684,
    width: 65.8,
    height: 65.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 3.95
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1937_4287"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1937_4287",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1937_4287",
    x1: -20,
    y1: -30.5369,
    x2: 75.8258,
    y2: 8.56886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBBCC7",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBBCC7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1937_4287",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-26.6228 5.60829) rotate(35.1112) scale(57.6443 34.0523)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.06
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1937_4287",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(64.6381 33.9561) rotate(161.34) scale(41.7879 28.303)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBBEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBBEFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_1937_4287",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.5444 -10.9342) rotate(47.2897) scale(27.9413 20.0791)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCyberSecurityIcon);
export default __webpack_public_path__ + "static/media/cyber-security_icon.11a1c07ea1c22763688f87620cd555d3.svg";
export { ForwardRef as ReactComponent };